import { Controller } from "@hotwired/stimulus"

// The dialog opens via the native show-modal command; this only seeds the
// client select from the invoking button: client card kebabs pass their client
// via data-client-id, the page-header button passes none.
export default class extends Controller {
  static targets = ["clientSelect"]

  prefill(event) {
    if (event.command !== "show-modal") return

    this.clientSelectTarget.value = event.source?.dataset.clientId || ""
  }
}
